var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      attrs: {
        label: _vm.label,
        prop: _vm.prop,
        rules: _vm.rules,
        size: _vm.size,
      },
    },
    [
      _c("el-input", {
        attrs: {
          placeholder: _vm.$t("inputText"),
          clearable: _vm.clearable,
          maxlength: "68",
        },
        model: {
          value: _vm.id,
          callback: function ($$v) {
            _vm.id = $$v
          },
          expression: "id",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }